export default "./dist/stdassets/images/icons/legend-DWF.png";